exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-active[data-v-140d72cb] {\n  font-weight: bold;\n  background: #f5f5f5;\n}\nul.menu-list[data-v-140d72cb] {\n  margin-bottom: 1em;\n}\ndiv.menu-head[data-v-140d72cb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\ndiv.menu-head a.has-toggle[data-v-140d72cb] {\n    font-size: 0.8em;\n}\ndiv.menu-head a[data-v-140d72cb] {\n    background: none;\n}\n.menu-head[data-v-140d72cb]:hover {\n  background-color: #f5f5f5;\n}\nrouter-link[data-v-140d72cb]:hover {\n  color: #ed9e1a;\n}\n", ""]);

// exports
